import type { IService } from 'restangular'

import { app } from '../../app.module'

/**
 * データ通信用サービス
 */
export class RestangularService {
  constructor(
    private Restangular: IService,
    private $q: ng.IQService
  ) {}
  /**
   * Restangularで通信
   * @param {string} requestType 通信タイプ(get or post)
   * @param {string} endpoint エンドポイント
   * @param {object} params 通信のパラメーター
   * @return {object} Promiseオブジェクト 結果
   */
  public request(requestType: string, endpoint: string, params: {}): ng.IPromise<any> {
    const deferred = this.$q.defer()
    let restangularPath

    switch (requestType) {
      case 'GET':
        restangularPath = this.Restangular.all(endpoint).customGETLIST(null, params)
        break

      case 'POST':
        restangularPath = this.Restangular.all(endpoint).customPOST(params)
        break

      case 'UPDATE':
        restangularPath = this.Restangular.all(endpoint).customPUT(params)
        break

      case 'DELETE':
        restangularPath = this.Restangular.all(endpoint).customDELETE('', params)
        break
    }

    restangularPath.then(deferred.resolve).catch((error) => {
      deferred.reject(error)
    })

    return deferred.promise
  }
}

app.service('RestangularService', RestangularService)
